<template>
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25.5 1.5L31.5 7.5L25.5 13.5" stroke="#7B8794" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.5 16.5V13.5C4.5 10.1863 7.18629 7.5 10.5 7.5H31.5" stroke="#7B8794" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.5 34.5L4.5 28.5L10.5 22.5" stroke="#7B8794" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M31.5 19.5V22.5C31.5 25.8137 28.8137 28.5 25.5 28.5H4.5" stroke="#7B8794" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>